import { render, staticRenderFns } from "./SpinnerFloat.vue?vue&type=template&id=618615d0&"
import script from "./SpinnerFloat.vue?vue&type=script&lang=js&"
export * from "./SpinnerFloat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports